import { render } from "./ViewSelection.vue?vue&type=template&id=06dd7a54&scoped=true"
import script from "./ViewSelection.vue?vue&type=script&lang=js"
export * from "./ViewSelection.vue?vue&type=script&lang=js"

import "./ViewSelection.vue?vue&type=style&index=0&id=06dd7a54&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dd7a54"]])

export default __exports__